var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExtTerm = function SvgExtTerm(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 28,
    height: 28,
    viewBox: "0 0 7.408 7.408",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "none",
    stroke: "currentColor",
    transform: "translate(0 -289.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    strokeWidth: 0.529,
    d: "m1.516 295.23-.56.559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1172",
    strokeWidth: 0.529,
    d: "m4.661 292.18-.862.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1120",
    strokeWidth: 0.529,
    d: "m6.385 290.66-.559.559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1162",
    strokeWidth: 0.529,
    d: "m5.892 295.22.559.559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1130",
    strokeWidth: 0.529,
    d: "m1.057 290.67.559.559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    strokeWidth: 0.529,
    d: "M3.704 289.66v.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1167",
    strokeWidth: 0.529,
    d: "M6.592 293.3h.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    strokeWidth: 0.529,
    d: "M.032 293.3h.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1084",
    strokeWidth: 0.529,
    d: "M1.838 295.28c-.483-.491-.854-1.237-.854-1.98a2.72 2.72 0 1 1 5.44 0c0 .745-.367 1.49-.853 1.981"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path831",
    cx: 3.704,
    cy: 293.3,
    r: 1.583,
    strokeWidth: 0.433
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExtTerm);
export default ForwardRef;